import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import https from "https";
import axios from "axios";
import log from "../utils/log";
import metaData from "../data/metaData";
import c from "../utils/common";

//
import useAuthStore from "../states/useAuth";

const useWelcome = () => {
  const { auth, user } = useAuthStore();

  const createWelcome = async (data) => {
    //
    let res = await axios.post(metaData.serverURL + "welcome", data, {
      headers: { Authorization: auth.jwt },
      httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
    });
   return res.data;
  };

  const updateWelcome = async (id, data) => {
    let res = await axios.patch(metaData.serverURL + "welcome", data, {
      params: { id: id }, // Pass the request ID as a query parameter if needed
      headers: { Authorization: auth.jwt },
      httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
    });
   return res.data;
  };

  return { createWelcome, updateWelcome };
};

export default useWelcome;
